module.exports = __webpack_public_path__ + "assets/e31c74323063b025fef2c0a046d242a6.png";